import actionCreator from '../../decorators/actionCreator';
import { REDUX_NAMESPACE } from './constants';
import { isArray, isEmptyString } from '../../../../util/object';
import Layer from '../../../../model/Layer';

const ACTION_CREATORS = {
  /**
   * Adds layers to a creative
   * @param {Layer[]} layers
   * @returns {{layers: Layer[]}}
   */
  @actionCreator(REDUX_NAMESPACE)
  addLayers(layers) {
    if (!isArray(layers)) {
      throw new Error('layers must be an array');
    }

    if (layers.some((layer) => !Layer.isLayer(layer))) {
      throw new Error('layers must contain Layers');
    }

    return {
      layers,
    };
  },

  /**
   * Remove layers from a creative
   * @param {Layer[]} layers
   * @returns {{layers: Layer[]}}
   */
  @actionCreator(REDUX_NAMESPACE)
  removeLayers(layers) {
    if (!isArray(layers)) {
      throw new Error('layers must be an array');
    }

    if (layers.some((layer) => !Layer.isLayer(layer))) {
      throw new Error('layers must contain Layers');
    }

    const missingId = layers.some((layer) => isEmptyString(layer.id));
    if (missingId) {
      throw new Error('Cannot remove layer without an ID');
    }

    return {
      layers,
    };
  },

  @actionCreator(REDUX_NAMESPACE)
  setLayerDescription(layerId, description) {
    return {
      description,
      layerId,
    };
  },

  /**
   * Updates layers in a creative
   * @param {Layer[]} layers
   * @returns {{layers: Layer[]}}
   */
  @actionCreator(REDUX_NAMESPACE)
  updateLayers(layers) {
    if (!isArray(layers)) {
      throw new Error('layers must be an array');
    }

    if (layers.some((layer) => !Layer.isLayer(layer))) {
      throw new Error('layers must contain Layers');
    }

    const missingId = layers.some((layer) => isEmptyString(layer.id));
    if (missingId) {
      throw new Error('Cannot update layer without an ID');
    }

    return {
      layers,
    };
  },
};

export default ACTION_CREATORS;
